<vs-dialog #createEmailTemplateDialog [config]="dialogConfig ?? { dialogContainerClass: 'max-w-[700px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      hideCloseButton: false,
      icon: 'plus-circle',
      iconTheme: 'primary',
      showDivider: true,
      title: 'Create Email Template',
      subtitle: 'Configure an email template for a supported event'
    }"
  ></vs-dialog-header>

  <form [formGroup]="form" class="mt-3">
    <vs-form-field theme="primary" [config]="{ label: 'Event' }">
      <vs-select vsInput formControlName="type">
        <li *ngFor="let type of emailTypes" vs-select-option [value]="type">{{ type }}</li>
      </vs-select>
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Template Label' }" class="mt-4">
      <input vsInput type="text" formControlName="templateLabel" placeholder="e.g. Default Distributor Created" />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Delivery Method' }" class="mt-4">
      <input vsInput type="text" value="Event Based" disabled />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Subject' }" class="mt-4">
      <input vsInput type="text" formControlName="subject" />
    </vs-form-field>

    <vs-form-field theme="primary" [config]="{ label: 'Byline' }" class="mt-4">
      <input vsInput type="text" formControlName="byline" />
    </vs-form-field>

    <label class="text-gray-700 font-medium" style="font-size: 0.875rem; line-height: 2.25rem">Content</label>
    <vs-rich-text-editor formControlName="content"></vs-rich-text-editor>
  </form>

  <div class="flex footer mt-5 gap-2 justify-end">
    <button vs-button size="md" appearance="outline" [disabled]="saving" (click)="cancel()">Cancel</button>
    <button vs-button size="md" theme="primary" [disabled]="saving || form.invalid" (click)="submit()">Create</button>
  </div>
</vs-dialog>
